const listDecimals: string[] = [
    'milésimo',
    'milionésimo',
    'bilionésimo',
    'trilionésimo',
    'quatrilionésimo',
    'quintilionésimo',
    'sextilionésimo',
    'septilionésimo',
    'octilionésimo',
    'nonilionésimo',
    'decilionésimo',
    'undecilionésimo',
    'duodecilionésimo',
]

export default listDecimals
